import type { RenderingQualitySettings } from './types'

const FALLBACK_RENDERING_QUALITY: RenderingQualitySettings = {
  pixelRatio: 1.5,
  antialias: false,
  frameRateCap: 60,
}

type RenderingQualityEnv = Pick<
  ImportMetaEnv,
  'VITE_VRM_PIXEL_RATIO_CAP' | 'VITE_VRM_ANTIALIAS' | 'VITE_VRM_FRAME_RATE_CAP'
>

const positiveNumberOr = (value: number | string | undefined, fallback: number): number => {
  if (value === undefined || value === '') return fallback
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

const frameRateOr = (value: number | string | undefined, fallback: number): number => {
  const parsed = positiveNumberOr(value, fallback)
  return parsed >= 1 ? parsed : fallback
}

const booleanOr = (value: boolean | string | undefined, fallback: boolean): boolean => {
  if (value === true || value === 'true') return true
  if (value === false || value === 'false') return false
  return fallback
}

/** 環境変数を既定値とし、viewer 単位の指定があればその項目だけ上書きする。 */
export const resolveRenderingQuality = (
  overrides: Partial<RenderingQualitySettings> = {},
  env: Partial<RenderingQualityEnv> = import.meta.env
): RenderingQualitySettings => ({
  pixelRatio: positiveNumberOr(
    overrides.pixelRatio,
    positiveNumberOr(env.VITE_VRM_PIXEL_RATIO_CAP, FALLBACK_RENDERING_QUALITY.pixelRatio)
  ),
  antialias: booleanOr(overrides.antialias, booleanOr(env.VITE_VRM_ANTIALIAS, FALLBACK_RENDERING_QUALITY.antialias)),
  frameRateCap: frameRateOr(
    overrides.frameRateCap,
    frameRateOr(env.VITE_VRM_FRAME_RATE_CAP, FALLBACK_RENDERING_QUALITY.frameRateCap)
  ),
})
